import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayout } from './layouts/app-layout.component';
import { AuthLayout } from './layouts/auth-layout.component';
import { KnowledgeBaseComponent } from './pages/knowledge-base';
import { FaqComponent } from './pages/faq';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: "",
        component: AppLayout,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'auth/login', pathMatch: 'full' }, // Redirecionamento para '/auth/login' ao acessar a raiz
            { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
            { path: 'hospitals', loadChildren: () => import('./features/hospitals/hospitals.module').then(m => m.HospitalsModule) },
            { path: 'health-plans', loadChildren: () => import('./features/health-plans/health-plans.module').then(m => m.HealthPlansModule) },
            { path: 'doctors', loadChildren: () => import('./features/doctors/doctors.module').then(m => m.DoctorsModule) },
            { path: 'surgical-procedures', loadChildren: () => import('./features/surgical-procedures/surgical-procedures.module').then(m => m.SurgicalProceduresModule) },
            { path: 'quotes', loadChildren: () => import('./features/quotes/quotes.module').then(m => m.QuotesModule) },
            { path: 'settings', loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule) },
            { path: 'pages/knowledge-base', component: KnowledgeBaseComponent, data: { title: 'Knowledge Base | Synapse' } },
            { path: 'pages/faq', component: FaqComponent, data: { title: 'FAQ | Synapse' } },
        ],
    },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            { path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
            { path: '', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
